module.exports = __webpack_public_path__ + "img/Hint.2972fa65.svg";